import { Link, useNavigate } from "react-router-dom";
import { Menu, X, Phone, Calendar, UserRound } from "lucide-react";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";

export function Logo({ dark = false, className = "" }) {
  return (
    <Link to="/" className={`flex items-center ${dark ? "bg-white/95 rounded-lg px-2.5 py-1 shadow-sm" : ""} ${className}`} data-testid="nav-logo">
      <img src="/blakes-logo.webp" alt="Blake's Quality Water" className="h-9 w-auto" />
    </Link>
  );
}

const links = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/#services" },
  { label: "Why Us", to: "/#why" },
  { label: "Pricing", to: "/#pricing" },
  { label: "Reviews", to: "/#reviews" },
  { label: "Contact", to: "/#coverage" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();

  const accountHref = user ? (user.role === "admin" ? "/admin" : user.role === "driver" ? "/driver" : "/account") : "/login";

  return (
    <header className="absolute top-5 inset-x-0 z-50 px-4 sm:px-6">
      <div className="max-w-[1280px] mx-auto bg-white rounded-[20px] shadow-[0_10px_30px_rgba(15,23,42,0.12)] border border-slate-100 h-16 flex items-center justify-between px-5">
        <Logo />
        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l, i) => (
            <a key={l.label} href={l.to} data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
              className={`text-sm font-semibold transition-colors ${i === 0 ? "text-blue-600" : "text-slate-600 hover:text-blue-600"}`}>
              {l.label}
              {i === 0 && <span className="block h-0.5 w-5 bg-blue-600 rounded-full mt-1" />}
            </a>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <Link to={accountHref} data-testid="nav-account-link"
            className="flex items-center gap-2 text-[#071A33] font-semibold text-sm px-3 py-2.5 rounded-full hover:bg-slate-100 transition-colors">
            <UserRound className="w-4 h-4 text-blue-600" /> {user ? (user.role === "customer" ? "My Account" : "Portal") : "Sign in"}
          </Link>
          <button onClick={() => navigate("/book")} data-testid="nav-book-delivery-btn"
            className="flex items-center gap-2 text-white font-semibold text-sm px-5 py-2.5 rounded-full btn-shine"
            style={{ background: "linear-gradient(135deg,#087FF5,#18B9F5)", boxShadow: "0 8px 20px -6px rgba(8,127,245,0.6)" }}>
            <Calendar className="w-4 h-4" /> Book Delivery →
          </button>
        </div>
        <button className="lg:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden max-w-[1280px] mx-auto bg-white border border-slate-100 rounded-2xl mt-2 px-5 py-4 space-y-3 shadow-lg">
          {links.map((l) => <a key={l.label} href={l.to} className="block text-slate-700 font-medium" onClick={() => setOpen(false)}>{l.label}</a>)}
          <Link to={accountHref} className="block text-slate-700 font-medium" onClick={() => setOpen(false)} data-testid="nav-account-mobile-link">{user ? (user.role === "customer" ? "My Account" : "Portal") : "Sign in"}</Link>
          <button onClick={() => navigate("/book")} className="text-white font-semibold w-full py-3 rounded-full" style={{ background: "linear-gradient(135deg,#087FF5,#18B9F5)" }} data-testid="nav-book-delivery-mobile-btn">Book Delivery →</button>
        </div>
      )}
    </header>
  );
}
